import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { TimeDurationInputComponent } from 'src/app/controls/time-duration-input/time-duration-input.component';
import { RichToolTipDirective } from 'src/app/directives/rich-tool-tip.directive';
import { WorkflowSettingsDialogData } from './models/workflow-settings-dialog-data';

@Component({
    selector: 'app-workflow-settings-dialog',
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        TimeDurationInputComponent,
        FontAwesomeModule,
        RichToolTipDirective,
    ],
    templateUrl: './workflow-settings-dialog.component.html',
    styleUrl: './workflow-settings-dialog.component.scss',
})
export class WorkflowSettingsDialogComponent implements OnInit {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    public maxDurationTooltipContent =
        "Spécifie la durée maximale de traitement d'un dossier pour ce workflow. Un dossier dont la création est antérieure à la date du jour moins cette durée est considéré comme en retard.<br/><br/><b>Utilisez le format : </b>2s 4j 6h 45m<br><ul><li>s = semaines</li><li>j = jours</li><li>h = heures</li><li>m = minutes</li></ul>";

    /**
     * Champs du formulaire de saisie de la durée maximale.
     */
    // public maxDurationFormControl = new UntypedFormControl(null, [Validators.required]);

    form: FormGroup;

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<WorkflowSettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WorkflowSettingsDialogData
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({ maxDuration: [this.data.maxDuration] });
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Enregistrer'.
     */
    public save(): void {
        console.log('form errors :', this.form.errors);
        this.data.maxDuration = this.form.get('maxDuration').value;
        this.dialogRef.close(this.data);
    }
}
